const brand = sessionStorage.getItem('brand');
export const home = {
  greetingText: 'Hej, ',
  greetingHand: '👋',
  upgrade: 'Uppgradera',
  integrate: 'Integrera',
  integrate2: 'Integrera',
  chatGPT: 'ChatGPT ',
  forYourBusiness: 'för ditt företag',
  insights: 'Insikter',
  message: 'Meddelanden',
  addon: 'Tillägg: ',
  leads: 'Leads',
  yourBots: 'Dina bots',
  botName: 'Botnamn',
  platform: 'Plattform',
  contactOrLeads: 'Kontakter/Leads',
  actions: 'Åtgärder',
  edit: 'redigera',
  delete: 'radera',
  createA: 'Skapa en ',
  whatsappChatbot: 'WhatsApp Chatbot ',
  connect: 'Anslut',
  getStartedWithUs: 'Kom igång med oss 👏',
  howToBuildAGoodChatFlow: ' Hur man skapar en bra chatflow',
  howToUseBotPenguinInboxAndItsFeatures: ` Hur man använder BotPenguins inkorg och dess funktioner`,
  botPenguinPricing: ` BotPenguins pris: Utforska planer och funktioner`,
  openHelpDesk: ' Öppna hjälpdesk',
  helpAndSupport: 'Hjälp och support',
  extensiveGuides: 'Utförliga guider för alla dina frågor och arbetsflöden finns tillgängliga i vår',
  resourceCentre: 'Resurscenter.',
  checkoutOurAnswers: 'Du kan kolla in våra svar på vanliga frågor nedan.',
  createANewBot: 'Skapa en ny bot',
  installYourBot: 'Installera din bot',
  plansAndPricing: 'Planer och prissättning',
  searchLanguage: 'Sök språk',
  whatsappConversations: 'WhatsApp-samtal',
  diveDeeperIntoBotPenguin: 'Dyk djupare in i BotPenguin',
  knowWhereWeAreGoing: 'Veta vart vi går, de senaste uppdateringarna och hjälp oss att fixa några buggar.',
  productUpdates: 'Produktuppdateringar',
  requestAFeature: 'Begär en funktion',
  reportABug: 'Rapportera en bugg',
  productRoadmap: 'Produktvägkarta',
  contactsOrLeads: 'Kontakter/Leads',
  english: 'Engelska',
  hindi: 'Hindi',
  german: 'Tyska',
  french: 'Franska',
  portuguese: 'Portugisiska',
  spanish: 'Spanska',
  italian: 'Italienska',
  russian: 'Ryska',
  pleaseSelectYourReason: 'Vänligen välj din anledning',
  cancel: 'Avbryt',
  submit: 'Skicka!',
  giveFeedback: 'Ge feedback',
  ratings: 'Betyg',
  reasonBehindYourDecision: 'Orsak till ditt beslut',
  shareYourExperience: 'Dela din upplevelse',
  reason1: 'orsak1',
  reason2: 'orsak2',
  appTooltip: {
    HOME_INSIGHT: 'Ge insikt i alla dina bots meddelanden och leads (Data uppdateras varje midnatt)',
    HOME_MESSAGES: 'Meddelanden konsumerade av ditt konto under den här faktureringscykeln. (Meddelanden från WhatsApp, Facebook och Telegram Bot är undantagna.)',
    HOME_TOTAL_MESSAGES: 'Totala meddelanden konsumerade av ditt konto sedan kontots skapande (Meddelanden från WhatsApp, Facebook och Telegram Bot är undantagna.)',
    LEADS: 'Leads fångade av bots för ditt konto under den här faktureringscykeln. ',
    TOTAL_LEADS: 'Totala kontakter/leads fångade av bots för ditt konto sedan kontots skapande (Data uppdateras varje midnatt).',
    YOUR_BOT: 'Översikt över alla dina bots och deras användning under den här faktureringscykeln.',
    NAME: 'Bots namn',
    PLATFORM: 'Bots plattform',
    MESSAGES: 'Bots totala meddelanden sedan kontots skapande',
    CONTACTS: 'Bots totala kontakter/leads',
    ACTIONS: 'Redigera/Radera boten',
    EDIT_ICON: 'Redigera botens chat-flöde och inställningar',
    DELETE_ICON: 'Radera boten',
    TOOL_TIP_CLASSIC_VERSION: `gammal version av ${brand} UI`
  },
  modal: {
    deleteBot: 'Radera bot!',
    areYouSure: 'Är du säker på att du vill radera den här boten?',
    enquiryForm: 'Förfrågningsformulär',
    payNow: 'Betala nu!',
    saveAndDelete: 'Spara och radera',
    submit: 'Skicka',
  },
  noDataFound: {
    bots: 'Bots',
    noBotCreatedYet: 'Inga bots skapade ännu!',
  },
  yourFriendWillMissYou: 'Din vän kommer att sakna dig',
  rateYourBotCreationExperience: 'Betygsätt din botskapelseupplevelse',
  whatMadeYouDeleteYourBot: 'Vad fick dig att radera din bot?',
  iCreatedByMistake: 'Jag skapade av misstag',
  iWantToCreateAnotherBot: 'Jag vill skapa en annan bot',
  couldNotFindFeaturesThatINeeded: 'Kunde inte hitta de funktioner jag behövde',
  uiWasHardToNavigate: 'UI var svårt att navigera',
  iDonotWantToTell: 'Jag vill inte säga',
  other: 'Annat',
  weWillDoOurBestToMakeAutomationFun: 'Vi kommer att göra vårt bästa för att göra automation roligt och enkelt för alla.',
};
